/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * payload JSON di ServizioMensaComunicazioneEmailForm
 */
export interface ServizioMensaComunicazioneEmailForm { 
    /**
     * Oggetto dell\'email. Non puo\' essere nullo o vuoto.
     */
    oggetto: string;
    /**
     * Contenuto HTML dell\'email. Non puo\' essere nullo o vuoto.
     */
    contenuto: string;
    /**
     * Filtro opzionale: id della scuola del servizio.
     */
    scuola_id?: string;
    /**
     * Filtro opzionale: classe (match esatto).
     */
    classe?: string;
    /**
     * Filtro opzionale: sezione (match esatto).
     */
    sezione?: string;
    /**
     * Genitori scelti uno per uno (id ServizioMensaAnagrafica del servizio, massimo 1000). Se presente sostituisce i filtri, che vanno lasciati vuoti: raggiunge anche i genitori con figli sospesi o Pratica non accettata.
     */
    anagrafica_ids?: Array<string>;
}

